export class CatalogFiltersCheckboxListExpand {

	private element: HTMLElement;

	constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init = (): void => {
		const expandButton = this.element.querySelector('.js-list-expand');
		if (!expandButton) return;

		expandButton.addEventListener('click', this.handleExpandClick);
	};

	private handleExpandClick = (): void => {
		const wrapper = this.element.querySelector('.js-list-wrapper');
		if (!wrapper) return;

		wrapper.classList.toggle('show-all');
	};
}